import axios from "axios";
import Config from "../utils/Config";

const BASE_URL = Config.apiUrl;

class EventsService {
  getHeaders() {
    const token = localStorage.getItem("token") || "";
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  }

  async getEvents() {
    try {
      const response = await axios.get(
        `${BASE_URL}/events/others`,
        this.getHeaders()
      );
      const body = response.data?.data ?? response.data;
      const list = Array.isArray(body?.data) ? body.data : (Array.isArray(body) ? body : []);
      return {
        status: true,
        data: body,
        list,
        message: body?.reason || "Events fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        list: [],
        message:
          error.response?.data?.message ||
          error.response?.data?.reason ||
          "An error occurred while fetching events",
      };
    }
  }
}

const eventsService = new EventsService();
export default eventsService;
